
import { Component, Prop, Vue } from 'vue-property-decorator'
@Component
export default class Detail extends Vue {
 @Prop() form!: any
}
